<template>
  <simple-layout horizontal>
    <loader indefinite v-if="operationSaving" message="Saving operation"></loader>
    <simple-layout vertical v-else-if="!operationSaving">
      <simple-layout>
        <operation-form-card
            :key="'form'+internalOperation.id"
            :operation="internalOperation"
            :default-operation-links="defaultOperationLinks"
            :operation-definition="operationDefinition(internalOperation.operationDefinition)"
            @save="handleSave"
            @cancel="handleCancel"
            :error="operationSaveError"
            :name="operation.id"/>

        <cash-event-list-card
            :cash-events="cashEvents"
            :key="'list'+internalOperation.id"
            @generatePayment="handleGeneratePayment"
            :name="operation.id"/>
        />
      </simple-layout>
    </simple-layout>
  </simple-layout>
</template>

<script>
import SimpleLayout from "@/components/layout/SimpleLayout";
import Loader from "@/components/Loader";
import OperationFormCard from "@/cards/OperationFormCard";
import CashEventListCard from "@/cards/CashEventListCard";
import {mapGetters} from "vuex";

export default {
  name: "OperationEditorLayout",
  components: {CashEventListCard, OperationFormCard, Loader, SimpleLayout},
  props: {
    operation: Object,
    defaultOperationLinks: Object
  },
  data: function () {
    return {
      cashEvents: [],
      internalOperation: {},
      operationSaveError: null,
      operationSaving: false
    }
  },
  computed: {
    ...mapGetters({
      operationDefinition: "operationDefinitions/operationDefinition",
      cashEventsByOperation: "cashEvents/cashEventsByOperation",
    })
  },
  methods: {
    handleSave(payload) {
      this.$emit('save', payload)
    },
    handleCancel() {
      if(this.$listeners.cancel) {
        this.$emit('cancel');
      }
      else {
        this.$router.back();
      }
    },
    handleGeneratePayment(payload) {
      this.$emit('generatePayment', payload);
    }
  },
  async mounted() {
    this.internalOperation = this.$_.cloneDeep(this.operation);
    await this.$store.dispatch("cashEvents/loadCashEventsByOperation", {operationId: this.internalOperation.id}).then(() => {
      this.cashEvents = this.cashEventsByOperation(this.internalOperation.id);
    });
  }
}
</script>

<style scoped>

</style>